import { render, staticRenderFns } from "./UserPermissionDialog.vue?vue&type=template&id=7c2ef5a4&scoped=true"
import script from "./UserPermissionDialog.vue?vue&type=script&lang=js"
export * from "./UserPermissionDialog.vue?vue&type=script&lang=js"
import style0 from "./UserPermissionDialog.vue?vue&type=style&index=0&id=7c2ef5a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2ef5a4",
  null
  
)

export default component.exports